// extracted by mini-css-extract-plugin
module.exports = {"coreParent":"CoreSolutions_coreParent__Jxzik"};